import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import Whatsapp from './Whatsapp'
export default function Career() {
  return (
    <div className="main-wrapper page">
       <Navbar />
  <div className="content-wrapper">
    <div className="career-opportunity">
      <div className="container">
        <div className="top-section">
          <div className="title-page">
            <h4 className="text-regular">Career Opportunity</h4>
          </div>
          <div className="sellect-career-opportunity">
            <form className="navbar-form no-margin">
              <label className="text-light">Filter</label>
              <ul className="list-item">
                <li className="input-box">
                  <input
                    type="text"
                    name="q"
                    className="input-search-keywords"
                    placeholder="Keywords"
                    autoComplete="off"
                  />
                </li>
                <li className="input-box">
                  <input
                    type="text"
                    name="q"
                    className="input-search-keywords"
                    placeholder="Location"
                    autoComplete="off"
                  />
                </li>
                <li className="select-rate select">
                  <div className="dropdown-toggle" data-toggle="dropdown">
                    <a href="#" className="option-button">
                      <span className="name">Rate ($40,000 - $60,000)</span>
                      <span className="select-icon">
                        <span className="lnr lnr-chevron-down" />
                      </span>
                    </a>
                  </div>
                  <ul className="dropdown-menu select-box">
                    <li className="selected">
                      <span>Rate ($40,000 - $60,000)</span>
                    </li>
                    <li>
                      <span>Rate ($40,000 - $60,000)</span>
                    </li>
                    <li>
                      <span>Rate ($60,000 - $80,000)</span>
                    </li>
                    <li>
                      <span>Rate ($80,000 - $100,000)</span>
                    </li>
                    <li>
                      <span>Rate ($100,000 - $120,000)</span>
                    </li>
                    <li>
                      <span>Rate ($120,000 - $140,000)</span>
                    </li>
                    <li>
                      <span>Rate (&gt; $140,000)</span>
                    </li>
                  </ul>
                </li>
                <li className="select-role select">
                  <div className="dropdown-toggle" data-toggle="dropdown">
                    <a href="#" className="option-button">
                      <span className="name">Fulltime</span>
                      <span className="select-icon">
                        <span className="lnr lnr-chevron-down" />
                      </span>
                    </a>
                  </div>
                  <ul className="dropdown-menu select-box">
                    <li>
                      <span>Fulltime</span>
                    </li>
                    <li>
                      <span>Freelancer</span>
                    </li>
                  </ul>
                </li>
                <li className="button-set">
                  <button type="submit" className="bnt text-regular">
                    Search
                  </button>
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="alumni-directory-content">
          <ul className="list-item">
            <li className="label-content">
              <span className="company">Company</span>
              <span className="position">Position</span>
              <span className="location">Location</span>
              <span className="rate">Rate</span>
              <span className="role">Role</span>
              <span className="applicant">Applicant</span>
              <span className="apply" />
            </li>
            <li className="box-content">
              <span className="company">
                <img src="images/company1.jpg" alt="" />
              </span>
              <span className="position">Marketing Manager</span>
              <span className="location">Los Angeles</span>
              <span className="rate">$45,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">29 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content even">
              <span className="company">
                <img src="images/company2.jpg" alt="" />
              </span>
              <span className="position">Social Media Expert</span>
              <span className="location">San Francisco</span>
              <span className="rate">$55,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">180 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content">
              <span className="company">
                <img src="images/company3.jpg" alt="" />
              </span>
              <span className="position">Front-End Developer</span>
              <span className="location">Bangkok</span>
              <span className="rate">$40,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">29 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content even">
              <span className="company">
                <img src="images/company4.jpg" alt="" />
              </span>
              <span className="position">Human Resources</span>
              <span className="location">Yogyakarta</span>
              <span className="rate">$45,000</span>
              <span className="role">Freelance</span>
              <span className="applicant">80 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content">
              <span className="company">
                <img src="images/company5.jpg" alt="" />
              </span>
              <span className="position">Product Designer</span>
              <span className="location">Los Angeles</span>
              <span className="rate">$45,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">29 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content even">
              <span className="company">
                <img src="images/company6.jpg" alt="" />
              </span>
              <span className="position">Copywriter</span>
              <span className="location">San Francisco</span>
              <span className="rate">$55,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">180 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content">
              <span className="company">
                <img src="images/company7.jpg" alt="" />
              </span>
              <span className="position">Full Stack Developer</span>
              <span className="location">Bangkok</span>
              <span className="rate">$40,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">60 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content even">
              <span className="company">
                <img src="images/company8.jpg" alt="" />
              </span>
              <span className="position">Human Resources</span>
              <span className="location">Yogyakarta</span>
              <span className="rate">$45,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">80 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content">
              <span className="company">
                <img src="images/company9.jpg" alt="" />
              </span>
              <span className="position">Marketing Manager</span>
              <span className="location">Los Angeles</span>
              <span className="rate">$45,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">29 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
            <li className="box-content even">
              <span className="company">
                <img src="images/company10.jpg" alt="" />
              </span>
              <span className="position">Social Media Expert</span>
              <span className="location">San Francisco</span>
              <span className="rate">$55,000</span>
              <span className="role">Fulltime</span>
              <span className="applicant">180 Applicants</span>
              <span className="apply">
                <a href="#" className="bnt bnt-theme">
                  Apply
                </a>
              </span>
            </li>
          </ul>
        </div>
        <div className="pagination-wrapper text-center">
          <ul className="pagination">
            <li className="prev">
              <a href="#">Previous</a>
            </li>
            <li>
              <a href="#">1</a>
            </li>
            <li>
              <a href="#">2</a>
            </li>
            <li className="current">
              <span>3</span>
            </li>
            <li>
              <a href="#">4</a>
            </li>
            <li>
              <a href="#">5</a>
            </li>
            <li className="next">
              <a href="#">Next</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    {/*begin newsletter*/}
    {/* <div className="newsletter newsletter-parallax" data-aos="fade-up">
          <div className="container">
            <div className="newsletter-wrapper text-center" data-aos="zoom-in" data-aos-delay="200">
              <div className="newsletter-title" data-aos="fade-down" data-aos-delay="300">
                <h2 className="heading-light">Keep Up and Join Our Newsletter</h2>
                <p className="text-white">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                </p>
              </div>

              <form name="subscribe-form" target="_blank" className="form-inline" data-aos="fade-up" data-aos-delay="400">
                <input
                  type="text"
                  className="form-control text-center form-text-light"
                  name="EMAIL"
                  defaultValue=""
                  placeholder="E-mail Address"
                />
                <button type="submit" className="button bnt-theme">
                  subscribe
                </button>
              </form>
            </div>
          </div>
        </div> */}
        <Whatsapp/>
    {/*end newsletter*/}
  </div>
  {/*End content wrapper*/}
  {/*Begin footer wrapper*/}
   <Footer />
  </div>
  )
}
